import ErrorPage from "@/components/pages/ErrorPage";
import { consentKeys, fetchConsentById, resolveConsentReadLocale } from "@/features/consent/api/selectConsentById";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

function DiaryConsentSetupLayout() {
    return <Outlet />;
}

export const Route = createFileRoute("/_app/diaries/$diaryId/setup/consent/$consentId")({
    component: DiaryConsentSetupLayout,
    errorComponent: ({ error, reset }) => <ErrorPage error={error as Error} reset={reset} />,
    loader: async ({ context: { queryClient }, params }) => {
        const locale = resolveConsentReadLocale();
        const consent = await queryClient.ensureQueryData({
            queryKey: consentKeys.byId(params.consentId, locale),
            queryFn: () => fetchConsentById(params.consentId, locale),
        });

        if (!consent || consent.diary_id !== params.diaryId) {
            throw redirect({
                to: "/diaries/$diaryId/home/to-do",
                params: { diaryId: params.diaryId },
            });
        }

        return { consentId: params.consentId };
    },
});
